import { render, staticRenderFns } from "./HolidayPlusChannelDashboard.vue?vue&type=template&id=02818a65&scoped=true"
import script from "./HolidayPlusChannelDashboard.vue?vue&type=script&lang=js"
export * from "./HolidayPlusChannelDashboard.vue?vue&type=script&lang=js"
import style0 from "./HolidayPlusChannelDashboard.vue?vue&type=style&index=0&id=02818a65&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02818a65",
  null
  
)

export default component.exports